<h1>Bfluence Integrity Dashboard</h1>
<div class="bflu-dashboard" *ngIf="kpis?.length">
  <div class="bflu-dashboard__group" *ngFor="let group of kpis">
    <div class="dashboard-card" [title]="group.description">
      <span
        class="header"
        [class.header--success]="!group.itemCount"
        [class.header--danger]="group.itemCount"
      >
        <div class="header__title">
          {{ group.name }}
          <p-button
            (onClick)="refreshGroup(group.id)"
            icon="pi pi-refresh"
            [rounded]="true"
            [text]="true"
            size="medium"
            styleClass="white-button"
          ></p-button>
        </div>
        <small
          tooltipPosition="bottom"
          [pTooltip]="
            timeDiffLabel(group.dateUpdated).includes('/')
              ? ''
              : timeLabel(group.dateUpdated) || ''
          "
        >
          última atualização:
          {{ timeDiffLabel(group.dateUpdated) }}
        </small>
      </span>
      <span class="value" [routerLink]="'/it-ops/bfluence/' + group.viewName">{{
        group.itemCount | number: '1.0-0'
      }}</span>
    </div>
  </div>
</div>
